import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Header from '../event_manage/Header';
import EventInvitePopulateLayout from './event-invite-populate/Layout';
import EventInviteLayout from './event-invite/Layout';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import useDialogRouter from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogRouter';
import { Helmet } from 'react-helmet-async';

Event.propTypes = {
  event: PropTypes.object.isRequired
};

export default function Event(props) {
  const { event } = props;

  const { id, route } = useDialogConfig();
  const router = useDialogRouter(id);

  useEffect(() => {
    if (route === '/') {
      // router.navigate('/invite-populate');
      router.navigate('/invite');
    }
  }, []);

  const pageMap = {
    '/invite': 'Invite',
    '/invite-populate': 'Invite'
  };

  const pathname = route.split('?')[0];
  const page = pageMap[pathname] || pathname;

  return (
    <>
      <Helmet>
        <title>
          {event.data.title ? `${event.data.title}: ${page}` : `Event #${event.id}: ${page}`}
        </title>
      </Helmet>
      <div className="px-6 pt-4 border-b border-cs-gray-100 pb-6">
        <Header event={event} />
      </div>
      <div className="flex-1 relative z-0 overflow-y-auto bg-cs-gray-50 px-6 py-6">
        {pathname === `/invite-populate` && (
          <EventInvitePopulateLayout
            event={event}
            onClose={props.onClose}
          />
        )}
        {pathname === `/invite` && (
          <EventInviteLayout
            event={event}
            router={router}
            onClose={props.onClose}
          />
        )}
      </div>
    </>
  );
};
